module.exports = isThunk

function isThunk(t) {
    return t && t.type === "Thunk"
}



//////////////////
// WEBPACK FOOTER
// ./~/virtual-dom/vnode/is-thunk.js
// module id = 14
// module chunks = 0